import {NgModule} from '@angular/core';

import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {RouterModule} from '@angular/router';
import {PlayersPage} from './players.page';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {AuthLibModule} from 'gamesis-auth';
import {HttpClientModule} from '@angular/common/http';
import {SharedModule} from '../components/shared.module';

@NgModule({
    declarations: [
        PlayersPage
    ],
    imports: [
        CommonModule,
        IonicModule,
        FormsModule,
        ReactiveFormsModule,
        AuthLibModule,
        HttpClientModule,
        RouterModule.forChild([
            {
                path: '',
                component: PlayersPage,
            }
        ]),
        SharedModule
    ],
    providers: []
})
export class PlayersModule {
}
